import { track } from '@fff-web/fff-analytics';

const ACTIVATION_COMPLETED_EVENT = 'Activation Completed';
const ACTIVATION_COMPLETED_EVENT_TYPE = 'Active';

const sendActivateSegmentEventAfterResponse = (status, ctaName, activationSource) =>
  track({
    trackName: ACTIVATION_COMPLETED_EVENT,
    properties: {
      activation_type: ACTIVATION_COMPLETED_EVENT_TYPE,
      activation_source: activationSource,
      cta_name: ctaName,
      status,
    },
  });

export default sendActivateSegmentEventAfterResponse;
